import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GET_ACCOUNTANTS_BY_ADMIN_ID } from "../../../api/apiAdmin";
import NoData from "../../atoms/NoData";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import Button from "../../atoms/Button";
import { FaArrowRight } from "react-icons/fa";
import { encryptId } from "../../../functions/idEncryptor";

const  AccountantsByAdmin = ({ id }) => {
    const navigate = useNavigate();
    const [contadores, setContadores] = useState();
    const [loading, setLoading] = useState(false);

    const getAccountants = useCallback (async () => {
		try {
            setLoading(true);
            const accountantsData = await GET_ACCOUNTANTS_BY_ADMIN_ID(id);
            const sortedData = accountantsData.sort((a ,b) => a.id - b.id);
            setContadores(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	}, [id]);

	useEffect(() => { 
        getAccountants(); 
    }, [getAccountants]);

    const handleNavigate = (id) => {
        navigate(`/contador/${encryptId(id)}/empresas`);
    };

    const columns = [
        {name: "Nombre", selector: row => row.name},
        {name: "Acciones", cell: row => (
            <div>
                <Button text={<FaArrowRight size={30}/>} bgColor="orange" width="w-12" onClick={()=> handleNavigate(row.id)}/>
            </div>
        )},
    ];

    return (
        <div className="rounded-b-lg p-2 border-t-0 md:border border-sky-400 mb-1">
            <DataTable
                data={contadores}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData/>}
                pagination
                responsive
            />
        </div>
    );
};

export default AccountantsByAdmin;